export const TypeWriterLabels = {
    first: "Building mobile experiences for 30M+ users.",
    second: "From CMS plugins to Flutter screens — I ship end-to-end.",
    third: "Architecture, automation, and a lot of coffee.",
    fourth: "I turn incidents into runbooks and experiments into insights.",
    fifth: "Senior Engineer at Talabat · Delivery Hero",
}